<!--
 * @Author: your name
 * @Date: 2020-08-26 15:52:26
 * @LastEditTime: 2026-07-27 16:29:41
 * @LastEditors: YangHan 1047143112@qq.com
 * @Description: In User Settings Edit
 * @FilePath: \kares\src\components\system\OrganizationManage.vue
-->
<template>
  <div class="organization-manage">
    <enfold>
      <enfold-uc>
        <template slot="up">
          <div class="c-u-left flex-b-c">
            {{ $t('system.StructureName') }}
            <div v-if="spaceInfo" style="margin-left: 32px; color: #000;">
              <span :style="`color:${spaceInfo.used_bytes > spaceInfo.total_bytes ? '#f00' : '#000'}`">
                {{ storageGB(spaceInfo.used_bytes) }}
              </span>
              /
              {{ storageGB(spaceInfo.total_bytes) }}
            </div>
          </div>
          <div class="c-u-right">{{ $t('system.Operate') }}</div>
        </template>
        <template slot="center">
          <el-tree :data="groupList" :props="{ children: 'child', label: 'name' }" default-expand-all
            :expand-on-click-node="false" v-loading="loading">
            <span class="custom-tree-node" slot-scope="{ node, data }">
              <span>{{ node.label }}</span>
              <div class="flex-a-c">
                <span>{{ showSpace(data) }}</span>
                <!-- <img v-if="$cookies.get('group_id') != data.id" class="icon"
                  src="@/assets/images/public/public_edit.png" @click="() => edit(data)" alt /> -->
                <popovers :content="$t('cspm5')">
                  <img v-if="$cookies.get('group_id') != data.id" class="icon"
                    src="@/assets/images/public/public_edit.png" @click="() => edit(data)" alt />
                </popovers>
              </div>
            </span>
          </el-tree>
        </template>
      </enfold-uc>
    </enfold>
    <form-dialog :dialogVisible="editDialogVisible" @closeDialog="editCloseDialog" :title="$t('nssm01')" dWidth="400px">
      <div class="form-dialog">
        <el-form :model="editForm" ref="editForm" label-width="124px">
          <el-form-item :label="$t('system.StructureName')" prop="name">
            <el-input v-model="editForm.name" disabled></el-input>
          </el-form-item>
          <el-form-item :label="$t('nssm02')" prop="name">
            <div v-if="spaceSelect !== '-1'">
              <el-select v-model="spaceSelect">
                <el-option v-for="item in spaceOptions" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </div>
            <div v-else>
              <el-input v-model="spaceValue" type="number" min="0">
                <template slot="append">GB</template>
              </el-input>
            </div>
            <span>{{ $t('nssm03') }}:{{ storageGB(spaceMax) }}</span>
          </el-form-item>
          <el-form-item>
            <el-button @click="resetEdit('editForm')" round>{{ $t('basics.Cancel') }}</el-button>
            <el-button type="primary" @click="submitEdit('editForm')" round>{{ $t('basics.Confirm') }}</el-button>
          </el-form-item>
        </el-form>
      </div>
    </form-dialog>
  </div>
</template>

<script>
import enfold from '@/components/basics/Enfold'
import EnfoldUc from '@/components/basics/EnfoldUC'
import FormDialog from '@/components/basics/FormDialog'
import Utils from "@/assets/scripts/Utils";
import { storage as storageGB } from "@/assets/scripts/publicFunction.js";
import { findNearestPrivateParent } from "@/assets/scripts/publicFunction";
import Popovers from "@/components/basics/Popover";
export default {
  name: "OrganizationManage",
  data() {
    return {
      FormDialogVisible: false,
      editDialogVisible: false,
      DelDialogVisible: false,
      onOffDialogVisible: false,
      loading: true,
      groupList: [],
      isSwitch: [],
      groupItem: {},
      editItem: {},
      listForm: {
        name: "",
      },
      editForm: {
        name: "",
      },
      spaceOptions: [
        { value: '0', label: this.$t('nssm04') },
        { value: '1', label: '1GB' },
        { value: '2', label: '2GB' },
        { value: '3', label: '3GB' },
        { value: '4', label: '4GB' },
        { value: '5', label: '5GB' },
        { value: '6', label: '6GB' },
        { value: '7', label: '7GB' },
        { value: '8', label: '8GB' },
        { value: '9', label: '9GB' },
        { value: '10', label: '10GB' },
        { value: '-1', label: this.$t('nssm05') },
      ],
      spaceSelect: '2',
      spaceMax: 0,
      spaceValue: 0,
      storageGB,
      spaceInfo: null
    }
  },
  created() {
    this.groupSpaceList();
    this.getSpaceInfo();
  },
  methods: {
    getSpaceInfo() {
      this.$http.post("/admin/SpaceService/getSpaceInfo", {}, (data) => {
        this.spaceInfo = data;
      })
    },
    showSpace(data) {
      const { allocated_space, is_private, id, pid, my_space } = data;
      // console.log(allocated_space, used_space, is_private, id, pid);
      if (pid === 0) {
        const mediaTotalSize = this.$cookies.get("mediaTotalSize");
        if (mediaTotalSize) {
          const { system_total_gb, system_percent } = mediaTotalSize
          return `${(system_total_gb * (1 - system_percent)).toFixed(2)}GB/${system_total_gb}GB`;
        } else {
          return '--';
        }
      }
      if (pid === 1) {
        return `${storageGB(my_space)}/${storageGB(allocated_space)}`;
      }

      if (is_private === 1) {
        return `${storageGB(my_space)}/${storageGB(allocated_space)}`;
      }

      const topGroup = findNearestPrivateParent(this.groupList, id);
      let show_space = topGroup?.allocated_space;
      if (!topGroup) {
        show_space = this.spaceInfo.total_bytes;
      }
      return `${storageGB(my_space)}/${this.$t('nssm06')}${storageGB(show_space || 0)}`;

    },
    groupSpaceList() {
      this.loading = true;
      this.$http.post("/admin/SpaceService/groupSpaceList", {}, data => {
        this.groupList = data;
        this.loading = false;
      });
    },
    FormCloseDialog() {
      this.FormDialogVisible = false;
    },
    editCloseDialog() {
      this.editDialogVisible = false;
    },
    resetForm(listForm) {
      this.$refs[listForm].resetFields();
      this.FormDialogVisible = false;
    },
    resetEdit(listForm) {
      this.$refs[listForm].resetFields();
      this.editDialogVisible = false;
    },
    submitEdit(listForm) {
      this.$refs[listForm].validate((valid) => {
        // console.log(valid, this.editItem.id, this.spaceSelect, this.spaceValue);
        if (valid) {
          // this.$http.post("/admin/access/editGroup", { id: this.editItem.id, name: this.editForm.name }, data => {
          //   console.log(data);
          //   this.editDialogVisible = false;
          //   this.getGroupList();
          // });
          let space = 0;
          if (this.spaceSelect !== '-1') {
            space = parseInt(this.spaceSelect);
            // console.log(this.spaceSelect);
          } else {
            space = this.spaceValue;
            // console.log(this.spaceValue);
          }

          space = space * 1024 * 1024 * 1024;

          const topGroup = findNearestPrivateParent(this.groupList, this.editItem.id);
          if (topGroup) {
            // console.log(this.editItem.id, space);
            // console.log(space);
            if (space > topGroup.allocated_space) {
              this.$msg({ type: 'warning', message: this.$t('nssm07') });
              return false;
            }
          } else {
            if (space === 0) {
              this.$msg({ type: 'warning', message: this.$t('nssm08') });
              return false;
            }
          }

          this.$http.post("/admin/SpaceService/editSpace", { group_id: this.editItem.id, space }, () => {
            this.groupSpaceList();
          });

          this.editDialogVisible = false;
          this.$refs[listForm].resetFields();
        } else {
          // console.log('error submit!!');
          return false;
        }
      });
    },
    edit(data) {
      this.editItem = data;
      this.editForm.name = data.name;
      console.log(this.editItem.id);
      const topGroup = findNearestPrivateParent(this.groupList, this.editItem.id);
      if (topGroup) {
        this.spaceMax = topGroup.allocated_space
      } else {
        const mediaTotalSize = this.$cookies.get("mediaTotalSize");
        this.spaceMax = mediaTotalSize.free_bytes;
      }
      this.editDialogVisible = true;
    },
    remove(data) {
      this.groupItem = data;
      this.DelDialogVisible = true;
    },
  },
  computed: {
    groupIdList() {
      let self = this;
      let data = Utils.MSDataTransfer.treeToArray(
        self.groupList,
        null,
        null,
        self.defaultExpandAll
      );
      return data;
    }
  },
  components: {
    enfold,
    FormDialog,
    EnfoldUc,
    Popovers
  }
}
</script>

<style lang="scss" scoped>
.organization-manage {
  width: 100%;
  height: 100%;

  .c-u-right {
    padding-right: 64px;
  }

  .el-tree {
    padding: 0px 20px;
  }

  .custom-tree-node {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 16px;
    padding-right: 8px;

    .icon {
      width: 30px;
      margin-left: 30px;
    }
  }

  /deep/ .el-tree-node__content {
    height: 40px;
    border-bottom: 1px dashed #d9d9d9;

    .el-button {
      margin-left: -26px;
    }
  }
}
</style>